import {
  COLLECTION_DETAIL_REQUEST,
  COLLECTION_DETAIL_SUCCESS,
  COLLECTION_DETAIL_FAILURE,
  COLLECTION_CAT_DETAIL_REQUEST,
  COLLECTION_CAT_DETAIL_SUCCESS,
  COLLECTION_CAT_DETAIL_FAILURE
} from "../actions/collectionActions";

const initialState = {
  items: [],
  categoryItem: [],
  loading: false,
  error: null,
};

const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case COLLECTION_DETAIL_REQUEST:
      return {
        ...state,
        // loading: true,
        // error: null,
      };
    case COLLECTION_DETAIL_SUCCESS:
      return {
        ...state,
        // loading: false,
        items: action.payload,
      };
    case COLLECTION_DETAIL_FAILURE:
      return {
        ...state,
        // loading: false,
        // error: action.payload,
        items: null,
      };


    case COLLECTION_CAT_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case COLLECTION_CAT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryItem: action.payload,
      };
    case COLLECTION_CAT_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        categoryItem: null,
      };

    default:
      return state;
  }
};

export default collectionReducer;